export default {
    install (Vue) {
        const files = require.context('../components', true, /\.(vue|js)$/i)
        files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
    }
}
